import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('user.routes.index'),
        name: 'user.index',
        component: () =>
            import(/* webpackChunkName: "users" */ '@/views/users/Index.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('user.breadcrumbs.index'),
                    to: { name: 'user.index' },
                    disable: true,
                },
            ],
            showName: i18n.t('user.breadcrumbs.index'),
        },
    },
    {
        path: '/' + i18n.t('user.routes.create'),
        name: 'user.create',
        child: true,
        component: () =>
            import(/* webpackChunkName: "users" */ '@/views/users/Create.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: 'Usuários',
                    to: { name: 'user.index' },
                    disable: false,
                },
                {
                    text: i18n.t('user.breadcrumbs.create'),
                    to: { name: 'user.create' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('user.routes.edit') + '/:id',
        name: 'user.edit',
        child: true,
        component: () =>
            import(/* webpackChunkName: "users" */ '@/views/users/Edit.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: 'Usuários',
                    to: { name: 'user.index' },
                    disable: false,
                },
                {
                    text: i18n.t('user.breadcrumbs.edit'),
                    to: { name: 'user.edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
